import imageCompression from "browser-image-compression";

export const compressBase64 = async (base64String) => {
    var file = await imageCompression.getFilefromDataUrl(base64String)
    const options = {
        maxSizeMB: 0.4,
        maxWidthOrHeight: 1080,
        useWebWorker: true,
    };
    var compressedFile = await imageCompression(file, options)
    var newBase64String = await imageCompression.getDataUrlFromFile(compressedFile)

    // console.log(newBase64String)
    return newBase64String
}